module.exports = __webpack_public_path__ + "fannie-mae-mockup.38LRAlUa.png";